import { Flex } from 'components/box';
import { css } from '@emotion/react';
import {
  ChevronLeft as IconPrevious,
  ChevronRight as IconNext,
  RotateCcw as IconReturnToStart,
} from 'react-feather';
import { Dispatch, SetStateAction } from 'react';

export enum NavigationButtonType {
  Previous = 'previous',
  Next = 'next',
  ReturnToStart = 'return-to-start',
}

type Variant = 'grey' | 'flat';

const ThumbnailNavigationButton = ({
  isEnabled,
  type,
  onClick,
  variant = 'flat',
  disableZoom,
  setCanShowSoldOutOverlay,
}: {
  isEnabled: boolean;
  type: NavigationButtonType;
  onClick: () => void;
  variant?: Variant;
  disableZoom?: () => void;
  setCanShowSoldOutOverlay?: Dispatch<SetStateAction<boolean>>;
}) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    onClick={() => void (isEnabled && onClick())}
    role="button"
    onMouseEnter={() => {
      if (disableZoom) {
        disableZoom();
      }
      if (setCanShowSoldOutOverlay) {
        setCanShowSoldOutOverlay(false);
      }
    }}
    onMouseLeave={() =>
      void (setCanShowSoldOutOverlay && setCanShowSoldOutOverlay(true))
    }
  >
    <Flex
      alignItems="center"
      justifyContent="center"
      css={theme => css`
        ${variant === 'grey' &&
        css`
          background-color: ${theme.colors.darkestGrey};
        `}

        ${variant === 'flat' &&
        css`
          background-color: white;
        `}

        border-radius: 100%;
        width: 32px;
        height: 32px;
        box-shadow: ${theme.shadows.medium};
        cursor: pointer;

        ${!isEnabled &&
        css`
          cursor: not-allowed;
          background-color: ${theme.colors.lightGrey};
        `}
      `}
    >
      {type === NavigationButtonType.Previous && (
        <IconPrevious
          size="24"
          css={theme => css`
            ${variant === 'grey' &&
            css`
              stroke: white;
            `}

            ${variant === 'flat' &&
            css`
              stroke: ${theme.colors.black};
            `}
          `}
        />
      )}

      {type === NavigationButtonType.Next && (
        <IconNext
          size="24"
          css={theme => css`
            ${variant === 'grey' &&
            css`
              stroke: white;
            `}

            ${variant === 'flat' &&
            css`
              stroke: ${theme.colors.black};
            `}
          `}
        />
      )}
      {type === NavigationButtonType.ReturnToStart && (
        <IconReturnToStart
          size="18"
          css={theme => css`
            ${variant === 'grey' &&
            css`
              stroke: white;
            `}

            ${variant === 'flat' &&
            css`
              stroke: ${theme.colors.black};
            `}
          `}
        />
      )}
    </Flex>
  </Flex>
);

export default ThumbnailNavigationButton;
